import {Part} from "./part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {BathTubType, bathTubTypeToString, LayoutType} from "../constants";
import {bathTubThumbnail} from "../assets";

import BathTubBody from "../subparts/bathTub/bathTubBody";
import BathTubBase from "../subparts/bathTub/bathTubBase";
import BathTubFixture from "../subparts/bathTub/bathTubFixture";
import BathTubRim from "../subparts/bathTub/bathTubRim";
import BathTubSpa from "../subparts/bathTub/bathTubSpa";
import BathTubTowelRack from "../subparts/bathTub/bathTubTowelRack";

export class Bathtub extends Part {
  static id = 'Bathtub';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.menuType = PartMenuType.Complex;
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub";
    this.partThumbnail = bathTubThumbnail;
    this.activeSubType_ = BathTubType.FreeStanding;
    this.bathTubBody = null;
    this.towelRack = null;
    this.bathtubRim = null;
    this.bathTubBase = null;
    this.bathTubFixture = null;
    this.bathTubSpa = null;
    this.relatedItems = [];
    this.bathTubType_ = BathTubType.FreeStanding;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Bathtub":
        relatedItemName = "bathTubBody";
        RelatedItemClass = BathTubBody;
        break;
      case "Fixture":
        relatedItemName = "bathTubFixture";
        RelatedItemClass = BathTubFixture;
        break;
      case "BathtubBase":
        relatedItemName = "bathTubBase";
        RelatedItemClass = BathTubBase;
        break;
      case "Bathtub - Spa":
        relatedItemName = "bathTubSpa";
        RelatedItemClass = BathTubSpa;
        break;
      case "BathtubRim":
        relatedItemName = "bathtubRim";
        RelatedItemClass = BathTubRim;
        break;
      case "Towel Rack":
        relatedItemName = "towelRack";
        RelatedItemClass = BathTubTowelRack;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  changeLayout(layoutType) {
    if (layoutType === LayoutType.Small) {
      // this.activeSubType_ = BathTubType.Custom60in;
      // this.bathTubType_ = BathTubType.Custom60in;
      if (!this.layout.parts.Shower.showerBody.disabled) { // disable bathtub if shower is active
        if (this.bathTubBody) {
          this.bathTubBody.disabled = true;
        }
        if (this.bathTubBase) {
          this.bathTubBase.disabled = true;
          this.bathTubBase.disabledClick();
        }
      }
    } else {
      if (this.bathTubBody) {
        this.bathTubBody.disabled = false;
      }
      if (this.bathTubBase) {
        this.bathTubBase.disabled = false;
        this.bathTubBase.disabledClick();
      }
    }
  }

  setLayers(layout, placeholdersNeeded) {
    const layers = [];
    this.getRelatedItems().forEach(relatedItem => {
      relatedItem.setLayers(layout);
      (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
        ? relatedItem.placeholderFeature.layer.addTo(layers)
        : relatedItem.activeFeature && relatedItem.activeFeature.layer.addTo(layers)
    });

    return layers;
  }

  navigationItem() {
    return new DesignNavigationItem('Bathtub', this)
  }

  subTypes() {
    return (this.bathTubBody && this.bathTubBase
      && this.bathTubBody.features.some(feature => feature.partName && !feature.partName.includes("laceholder"))
      && this.bathTubBase.features.some(feature => feature.partName && !feature.partName.includes("laceholder"))
    ) ? [
      BathTubType.Custom60in,
      BathTubType.FreeStanding
    ] : [];
  }

  subTypeToString(subType) {
    return bathTubTypeToString(subType);
  }

  isSubTypeWithItems() {
    return true;
  }

  getRelatedItems() {
    return this.relatedItems.filter(item => item.visible.includes(this.bathTubType_))
      .sort((a, b) => a.partName !== b.partName ? a.partName < b.partName ? -1 : 1 : 0);  // sort by partName
  }

  subParts() {
    return this.getRelatedItems().map(_ => new DesignNavigationItem(_.partName, _));
  }

  setDefault(layout) {
    this.getRelatedItems().forEach(relatedItem => relatedItem.setDefault(layout));
  }

  handleSubPartClick() {}

  handleSubTypeClick(subType) {
    this.bathTubType_ = subType;
    this.activeSubType_ = subType;  // BathTubType.Custom60in or BathTubType.FreeStanding
    this.bathTubFixture.disabled = (this.activeSubType_=== BathTubType.Custom60in)
      ? this.bathTubBase.disabled
      : this.bathTubBody.disabled
  }

  setDefaultPartAfterSubTypeClick() {
    // return (this.bathTubType_ === BathTubType.Custom60in) ? this.subParts()[0] : null
    return this.subParts()[0]
  }

  activeSubType() {
    return this.activeSubType_;
  }

  getFixtureType() {
    if (this.activeSubType_ === BathTubType.FreeStanding && this.bathTubBody && this.bathTubBody.activeFeature) {
      return this.bathTubBody.activeFeature.metaData["Fixture"]
    }
    return ["All"]
  }
}
